import * as api from '../api'
import { Dispatch } from '@reduxjs/toolkit';
import { endLoading, setContactUs, startLoading } from '../reducers/contactUsSlice';

export const actionCreateContactUsMessage = ({postData}: api.ApiParams) => async(dispatch: Dispatch) => {
    try{
        dispatch({ type: startLoading.type })
        const {data} = await api.createContactUsMessage({postData});
        dispatch({
            type: setContactUs.type,
            payload: data
        })
        dispatch({ type: endLoading.type })
        return data
    }catch(error: any){
        dispatch({ type: endLoading.type });
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}